import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const HeaderBox = styled.header`
  position: relative;
  background-color: var(--white-color);
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

export const FirstBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  height: clamp(3.75rem, 5vw + 1.25rem, 4.5rem);
  padding: 0 clamp(1rem, 4vw, 2rem);
  background-color: var(--white-color);
  /* Mesma faixa verde do header desktop. */
  border-bottom: 0.1875rem solid var(--second-color);
`;

export const LogoButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`;

export const LogoImg = styled.img`
  height: clamp(2rem, 4vw + 1rem, 2.5rem);
  width: auto;
  object-fit: contain;
`;

export const ButtonsBox = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const IconActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  background-color: ${(props) =>
    props.$active ? 'rgba(0, 137, 58, 0.12)' : 'transparent'};
  color: var(--second-color);
  transition: all 0.2s ease;

  svg {
    width: 1.5rem;
    height: 1.5rem;
    color: var(--second-color);
  }

  &:hover {
    background-color: rgba(0, 137, 58, 0.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const FullScreenNav = styled.nav`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background-color: var(--white-color);
  z-index: 99999;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: fadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.98);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const FullScreenHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  height: clamp(3.75rem, 5vw + 1.25rem, 4.5rem);
  padding: 0 clamp(1rem, 4vw, 2rem);
  background-color: var(--white-color);
  border-bottom: 1px solid rgba(0, 137, 58, 0.12);
  flex-shrink: 0;
`;

export const FullScreenContent = styled.div`
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 1.25rem 1.25rem 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1.25rem;
`;

export const MenuNavList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`;

export const MenuItemWrapper = styled.div`
  position: relative;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding-bottom: 0.35rem;
  margin-bottom: 0.35rem;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
  }
`;

export const HomeLink = styled(NavLink)`
  color: var(--first-color);
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 700;
  padding: 0.85rem 0.875rem;
  border-radius: 0.5rem;
  text-decoration: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  margin-bottom: 0.35rem;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  transition: all 0.2s ease;

  &.active {
    color: var(--second-color);
    background-color: rgba(0, 137, 58, 0.08);
  }

  @media (hover: hover) {
    &:hover {
      color: var(--second-color);
      background-color: rgba(0, 137, 58, 0.04);
    }
  }
`;

export const MenuButton = styled.button`
  color: ${(props) => (props.$isOpen ? 'var(--second-color)' : 'var(--first-color)')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-size: 1rem;
  font-weight: 700;
  padding: 0.85rem 0.875rem;
  border-radius: 0.5rem;
  text-align: left;
  background: ${(props) => (props.$isOpen ? 'rgba(0, 137, 58, 0.06)' : 'transparent')};
  outline: none;
  -webkit-tap-highlight-color: transparent;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
  }

  .chevron-icon {
    color: var(--second-color);
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    &.open {
      transform: rotate(180deg);
    }
  }

  @media (hover: hover) {
    &:hover {
      color: var(--second-color);
      background-color: rgba(0, 137, 58, 0.04);
    }
  }
`;

export const DropdownWrapper = styled.div`
  padding: 0.5rem 0.25rem 0.75rem;
  margin-top: 0.25rem;
`;

export const ActionButtonsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.75rem;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
`;

export const PortalButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.75rem 1.25rem;
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--first-color);
  background-color: transparent;
  border: 1.5px solid var(--first-color);
  border-radius: 0.625rem;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
  }

  svg {
    color: var(--first-color);
    transition: color 0.2s ease;
  }

  @media (hover: hover) {
    &:hover {
      background-color: var(--first-color);
      color: var(--white-color);
      svg {
        color: var(--white-color);
      }
      box-shadow: 0 4px 12px rgba(15, 78, 43, 0.2);
    }
  }

  &:active {
    background-color: var(--first-color);
    color: var(--white-color);
    svg {
      color: var(--white-color);
    }
  }
`;

export const SearchModalBox = styled.div`
  background-color: var(--white-color);
  width: min(92vw, 26rem);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.25);
  border-radius: 1rem;
  padding: 1.5rem 1.5rem 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  border: 1px solid rgba(0, 137, 58, 0.15);
  outline: none;
`;

export const SearchModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    font-size: 1.125rem;
    font-weight: 700;
    color: var(--first-color);
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--octave-color);
    padding: 0.35rem;
    border-radius: 0.375rem;
    outline: none;
    -webkit-tap-highlight-color: transparent;
    transition: color 0.2s ease, background-color 0.2s ease;

    &:hover {
      color: var(--first-color);
      background-color: rgba(0, 137, 58, 0.08);
    }
  }
`;

